var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-sidebar",class:{ collapsed: _vm.collapsed }},[_c('ul',{staticClass:"app-sidebar-nav"},[_vm._t("default")],2),_c('ul',{staticClass:"app-sidebar-nav app-sidebar-footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }